








































































































































import {
  RequisitionFilterParams,
  RequisitionStatus,
  RequisitionStatusEnum
} from '@/models';
import EmployeeUserPicker from '../employee/EmployeeUserPicker.vue';
import mixins from '@/utils/mixins';
import Auth from '@/mixins/auth';

export default mixins(Auth).extend({
  name: 'PurchaseRequisitionSearchFilter',

  components: { EmployeeUserPicker },

  props: {
    open: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      filterParams: {} as RequisitionFilterParams,
      stateList: [
        new RequisitionStatus({
          value: RequisitionStatusEnum.Draft,
          display_name: 'Draft'
        }),
        new RequisitionStatus({
          value: RequisitionStatusEnum.Submitted,
          display_name: 'Submitted'
        }),
        new RequisitionStatus({
          value: RequisitionStatusEnum.InReview,
          display_name: 'Review In Progress'
        }),
        new RequisitionStatus({
          value: RequisitionStatusEnum.Approval2Pending,
          display_name: 'Approval II Pending'
        }),
        new RequisitionStatus({
          value: RequisitionStatusEnum.Approval3Pending,
          display_name: 'Approval III Pending'
        }),
        new RequisitionStatus({
          value: RequisitionStatusEnum.Approval4Pending,
          display_name: 'Approval IV Pending'
        }),
        new RequisitionStatus({
          value: RequisitionStatusEnum.Approved,
          display_name: 'Approved'
        }),
        new RequisitionStatus({
          value: RequisitionStatusEnum.Rejected,
          display_name: 'Rejected'
        }),
        new RequisitionStatus({
          value: RequisitionStatusEnum.BuyerAssigned,
          display_name: 'Buyer Assigned'
        }),
        new RequisitionStatus({
          value: RequisitionStatusEnum.PurchaseInProgress,
          display_name: 'Purchase In Progress'
        }),
        new RequisitionStatus({
          value: RequisitionStatusEnum.PurchaseDelivered,
          display_name: 'Purchase Complete'
        }),
        new RequisitionStatus({
          value: RequisitionStatusEnum.Cancelled,
          display_name: 'Cancelled'
        }),
        new RequisitionStatus({
          value: RequisitionStatusEnum.Received,
          display_name: 'Received'
        })
      ]
    };
  },

  computed: {
    openValue: {
      get(): boolean {
        return this.open;
      },
      set(val: boolean) {
        if (val === this.open) return;
        this.$emit('update:open', val);
      }
    }
  },

  methods: {
    closeSearchFilterDialog() {
      this.openValue = false;
      // reset filter params back to empty object
      this.resetFilterParams();
    },

    resetFilterParams() {
      this.filterParams = {};
    },

    openSearchFilterDialog(params: RequisitionFilterParams) {
      if (params.state != null && !isNaN(params.state)) {
        this.filterParams.state = Number(params.state);
      }

      if (params.po_number) {
        this.filterParams.po_number = params.po_number;
      }

      if (this.isUserRequisitionAdmin) {
        if (params.owner != null && !isNaN(params.owner)) {
          this.filterParams.owner = Number(params.owner);
        }
      }

      this.openValue = true;
    },

    save() {
      this.$emit('change', this.filterParams);
      this.closeSearchFilterDialog();
    }
  }
});
